import { useState, useEffect } from "react";
import { useLogin } from "../../hooks/useLogin";
import { Link, useNavigate } from "react-router-dom";
import Numetrics from "../../assets/numetrics.svg";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const {
    login,
    error,
    isPending,
    ssoProviderId,
    checkEmail,
    completeSsoRedirect,
  } = useLogin();

  const navigate = useNavigate();

  // Returning from the district's identity provider: land where a password
  // login lands.
  useEffect(() => {
    completeSsoRedirect().then((success) => {
      if (success) navigate("/");
    });
    // Once per page load; getRedirectResult yields a result only once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Wait for login to finish
    const success = await login(email, password);
  
    // If we got 'true', then navigate to "/"
    // which leads to CIP page under your new route structure
    if (success) {
      navigate("/");
    } else {
    }
  };

  return (
    <div>
      <>
        <div className="min-h-full flex bg-slate-50 items-center align-center justify-center py-12 px-4 sm:px-6 lg:px-8">
          <div className="max-w-md w-full space-y-8 shadow-lg border-b-2">
            <div className="px-5 pb-12">
              <h2 className="mt-6 text-center text-3xl font-extrabold text-zinc-700">
                Sign in to your account
              </h2>
              <p className="mt-2 text-center text-sm text-gray-600">
                Need to register?{" "}
                <Link
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                  to="/signup"
                >
                  Register as a new user
                </Link>
              </p>

              {error && (
                <div
                  className="bg-red-50/60 w-full flex flex-row items-center border-l-2 border-red-400 text-red-600 my-4 px-3 py-3 rounded-r-md relative gap-2 font-medium"
                  role="alert"
                >
                  <div>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      className="w-6 h-6 text-red-500 row-span-2"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>

                  <span>{error}</span>

                </div>
              )}
              <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                <input type="hidden" name="remember" defaultValue="true" />
                <div className="rounded-md shadow-sm -space-y-px">
                  <div>
                    <label htmlFor="email-address" className="sr-only">
                      Email address
                    </label>
                    <input
                      required
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      onBlur={() => checkEmail(email)}
                      value={email}
                      autoComplete="email"
                      className={`appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 ${
                        ssoProviderId ? "rounded-md" : "rounded-t-md"
                      } focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm`}
                      placeholder="Email address"
                    />
                  </div>
                  {!ssoProviderId && (
                  <div>
                    <label htmlFor="password" className="sr-only">
                      Password
                    </label>
                    <input
                      onChange={(e) => setPassword(e.target.value)}
                      value={password}
                      id="password"
                      name="password"
                      type="password"
                      autoComplete="current-password"
                      required
                      className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                      placeholder="Password"
                    />
                  </div>
                  )}
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center">

                  </div>

                  <div className="text-sm">
                  <Link
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                  to="/forgot-password"
                >
                      Forgot your password?
              </Link>
                  </div>
                </div>

                <div>
                  {!isPending && (
                    <button
                      type="submit"
                      className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-700 hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      {" "}
                      {isPending && (
                        <button className="btn" disabled>
                          loading...
                        </button>
                      )}
                      <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                        <div
                          className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                          aria-hidden="true"
                        ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                        <path fillRule="evenodd" d="M12 1.5a5.25 5.25 0 0 0-5.25 5.25v3a3 3 0 0 0-3 3v6.75a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-6.75a3 3 0 0 0-3-3v-3c0-2.9-2.35-5.25-5.25-5.25Zm3.75 8.25v-3a3.75 3.75 0 1 0-7.5 0v3h7.5Z" clipRule="evenodd" />
                      </svg>
                      </div>
                      </span>
                      {ssoProviderId ? "Continue" : "Sign in"}
                    </button>
                  )}
                </div>
              </form>
            </div>
            <div className="bg-white py-4 rounded-b-xl">
              <img
                className="h-[20px] mx-auto w-auto"
                src={Numetrics}
                alt="NuMetrics"
              />
            </div>
          </div>
        </div>
      </>
    </div>
  );
}
